import { supabase } from './supabase';

export interface UserProfile {
  id: string; // Gerçek DB kolonu `user_id`dir — bkz. bitmiyo/supabase_schema.sql
  email?: string;
  full_name?: string;
  avatar_url?: string;
  role: string; // 'user' | 'seller' | 'educator' | 'admin' — paylaşılan profiles tablosu
  is_banned?: boolean;
}

function mapProfileRow(row: any): UserProfile {
  return {
    id: row.user_id,
    email: row.email,
    full_name: row.full_name,
    avatar_url: row.avatar_url,
    role: row.role,
    is_banned: Boolean(row.is_banned),
  };
}

/**
 * Paylaşılan public.profiles tablosundan rolü OKUR — sinif tarafı bu tabloya
 * asla yazmaz. Rol ataması yalnızca bitmiyo.com.tr/yonetim panelinden yapılır
 * (bkz. SINIF_PLATFORM_PLAN.md §2.4, §6).
 */
export async function fetchUserProfile(userId: string): Promise<UserProfile | null> {
  if (!userId) return null;
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('user_id', userId)
    .single();

  if (error || !data) return null;
  return mapProfileRow(data);
}
